import React, { Fragment } from 'react';
import { Intro, DragAndDrop } from 'abbot-core';
import img from '../../assets/images/U1-T2-4-3.svg';

const question = 'Decide if each statement is true or false.';

const NUTRITIOUS_FOOD =
  'Nutritious food choices are usually high in saturated and trans fats.';
const LABEL =
  'Nutrition labels list information that is necessary for you to make the best food choices you can.';
const DIABETES =
  'Type 2 diabetes is a noncommunicable disease that may be prevented by making nutritious food choices.';
const PACKAGING =
  'Food and drinks are packaged as single servings, which is reflected in the information on the nutrition label.';
const FRUITS =
  'Anything made with fruits and vegetables is a nutritious food choice.';

const dragOptions = [NUTRITIOUS_FOOD, LABEL, DIABETES, PACKAGING, FRUITS];

const dropZoneMessage = 'Drag elements here';

const TRUE = 'True';
const FALSE = 'False';

const dropZones = [TRUE, FALSE];

const data = {
  dragOptions,
  dropZones,
  dropZoneMessage,
  question
};

const correctInput = {
  [TRUE]: [LABEL, DIABETES],
  [FALSE]: [NUTRITIOUS_FOOD, PACKAGING, FRUITS]
};

const feedback = {
  // TODO do not let this feedback make it into the final version
  success: {
    title: 'Well done!',
    body: ''
  },
  error: {
    title: 'Not exactly.',
    body: ''
  },
  retry: {
    title: 'Not quite, give it another try',
    body: ''
  }
};

export default {
  title: 'Question 3',
  path: '/challenge/question-3',
  content: (
    <Fragment>
      <Intro
        title="Show What You Learned"
        direction="Select the category that best describes each statement."
        img={img}
      />

      <DragAndDrop
        data={data}
        question={question}
        correctInput={correctInput}
        feedback={feedback}
        score={2}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/challenge/Question3.js